import { render, staticRenderFns } from "./AddStockMovementPage.vue?vue&type=template&id=fc16b7d4"
import script from "./AddStockMovementPage.vue?vue&type=script&lang=js"
export * from "./AddStockMovementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports